import React, { useEffect, useState } from "react";

export default function TodayTasksPanel() {
  const [todayRows, setTodayRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [markDone, setMarkDone] = useState(false);

  useEffect(() => {
    async function fetchToday() {
      try {
        const res = await fetch("https://dev.bibhup.co.in/webhook/today");
        const data = await res.json();

        // Remove 1st unwanted header row
        const cleaned = data.slice(0);

        // Remove first column from each row
        const processed = cleaned.map((row) => {
          const entries = Object.entries(row).slice(1);
          return Object.fromEntries(entries);
        });

        setTodayRows(processed);
      } catch (err) {
        console.error("Error fetching today tasks:", err);
      }
    }
    fetchToday();
  }, []);

  return (
    <div className="w-full h-full bg-purple-200 p-3 flex flex-col">
      <h2 className="font-bold text-lg mb-3">Today's Questions</h2>

      {/* TABLE CONTAINER WITH SCROLL */}
      <div className="flex-1 overflow-auto border bg-white rounded shadow">
        <table className="min-w-max text-sm">
          <thead className="bg-gray-300 sticky top-0 z-10 text-left">
            <tr>
              <th className="border px-3 py-2">Qno</th>
              <th className="border px-3 py-2">Question</th>
              <th className="border px-3 py-2">1st Attempt Remarks</th>
              <th className="border px-3 py-2">Action</th>
            </tr>
          </thead>

          <tbody>
            {todayRows.map((row, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="border px-3 py-2">{row["Qno"] ?? row["col_2"]}</td>

                <td className="border px-3 py-2">
                  {row["Question Url"] ?? row["col_3"]}
                </td>

                <td className="border px-3 py-2">
                  {row["1st Attempt Remarks"] ?? row["col_11"] ?? ""}
                </td>

                <td className="border px-3 py-2">
                  <button
                    onClick={() => {
                      setSelectedRow(row);
                      setMarkDone(false);
                    }}
                    className="px-2 py-1 bg-blue-500 text-white rounded"
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* DETAILS SECTION BELOW TABLE */}
      {selectedRow && (
        <div className="mt-4 p-4 border rounded bg-white shadow max-h-60 overflow-auto">
          <h3 className="font-bold text-md mb-2">Full Details</h3>

          <div className="max-h-40 overflow-auto border p-2 bg-gray-50 rounded">
            {Object.entries(selectedRow).map(([key, value]) => (
              <p key={key} className="text-sm">
                <b>{key}:</b> {value?.toString()}
              </p>
            ))}
          </div>

          {/* Mark As Done */}
          <div className="flex items-center mt-3">
            <input
              type="checkbox"
              checked={markDone}
              onChange={() => setMarkDone(!markDone)}
              className="mr-2"
            />
            <label className="font-medium">Mark as Done</label>
          </div>

          <button
            onClick={() => setSelectedRow(null)}
            className="mt-3 px-3 py-1 bg-red-500 text-white rounded"
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
}
